import React, { useEffect, useState } from "react";
import UserLayout from "../layout/UserLayout";

const ITEMS_PER_PAGE = 12;

const CoconutProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetch("https://ceymoslanka.com/backend/api/coconut_manager/get_coconut_products.php")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const current = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <UserLayout>
      <div className="max-w-6xl mx-auto px-4 pt-24 pb-16">

        <h1 className="text-4xl font-bold text-gray-900">Coconut Products</h1>
        <div className="w-20 h-[3px] bg-gray-900 mt-1 mb-6"></div>

        <p className="text-gray-700 text-lg w-full mb-4">
          Sri Lankan coconut products are world-renowned for their
          <span className="font-semibold text-[#C8A951]"> natural purity</span>,
          <span className="font-semibold text-[#C8A951]"> rich nutrition</span>,
          and exceptional freshness. Harvested from the tropical coastal belts and
          coconut triangle of Sri Lanka, each product reflects the island’s
          unmatched quality standards and sustainable agricultural heritage.
        </p>

        <p className="text-gray-700 text-base w-full mb-6">
          Sri Lanka’s unique tropical climate, fertile soil, and traditional
          coconut-farming expertise make Ceylon coconut a global benchmark for
          <span className="italic text-[#C8A951]">clean, natural, and premium-grade</span>
          coconut-based products. From oil-rich nuts to nutrient-packed kernel
          extracts, every product is carefully processed to preserve
          <span className="italic text-[#C8A951]">freshness</span>,
          <span className="italic text-[#C8A951]">aroma</span>, and
          <span className="italic text-[#C8A951]">nutritional value</span>.
        </p>

        <ul className="text-gray-700 text-base w-full mb-10 list-disc list-inside space-y-2">

          <li>
            <span className="font-semibold text-[#C8A951]">Harvested from premium Sri Lankan plantations</span>
            known for dense nutrition and rich oil content.
          </li>

          <li>
            Processed using <span className="font-semibold text-[#C8A951]">modern, hygienic techniques</span>
            that preserve the natural taste and goodness.
          </li>

          <li>
            Naturally rich in <span className="font-semibold text-[#C8A951]">healthy fats, minerals, and antioxidants</span>
            that support energy, skin health, and overall wellness.
          </li>

          <li>
            Available in versatile <span className="font-semibold text-[#C8A951]">food, cosmetic, and industrial</span>
            product forms to meet global consumer and commercial needs.
          </li>

          <li>
            A <span className="italic text-[#C8A951]">sustainably sourced Sri Lankan export</span>
            trusted by international markets for purity and consistency.
          </li>
        </ul>

        <p className="text-gray-700 text-base w-full mb-12">
          At Ceymos Lanka, we proudly deliver a curated range of coconut products
          that embody Sri Lanka’s natural richness. Each item is processed and
          packed with exceptional care to ensure superior purity, unmatched taste,
          and world-class export quality — allowing you to experience the
          <span className="font-semibold text-[#C8A951]">true essence of Sri Lankan coconut</span>
          in every product.
        </p>


        {loading ? (
          <p className="text-center text-gray-600">Loading products...</p>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {current.map((p) => (
                <a
                  key={p.id}
                  href={`/coconut/${p.id}`}
                  className="border rounded-lg bg-white shadow-sm hover:shadow-md transition block"
                >
                  <img
                    src={
                      p.image
                        ? `https://ceymoslanka.com/backend/uploads/coconut_products/${p.image}`
                        : "https://via.placeholder.com/400x300?text=No+Image"
                    }
                    alt={p.title}
                    className="w-full h-56 object-cover rounded-t-lg"
                  />

                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {p.title}
                    </h3>

                    <p className="text-gray-800 font-medium mt-3">
                      Net Weight: {p.net_weight}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            <div className="flex justify-center gap-2 mt-10">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <button
                  key={num}
                  onClick={() => setPage(num)}
                  className={
                    num === page
                      ? "px-4 py-2 border border-gray-800 rounded text-gray-900 font-semibold"
                      : "px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
                  }
                >
                  {num}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </UserLayout>
  );
};

export default CoconutProducts;
